import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10 py-10 max-w-4xl mx-auto" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "Add a Job", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($options.addJob && $options.addJob(...args)), ["prevent"])),
      class: "space-y-6"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "jobTitle",
          class: "block text-sm font-medium text-gray-700"
        }, "Job Title", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "jobTitle",
          class: "mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.jobTitle) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, $data.jobTitle]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "company",
          class: "block text-sm font-medium text-gray-700"
        }, "Company", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "company",
          class: "mt-1 block w-1/2 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.company) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, $data.company]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          for: "description",
          class: "block text-sm font-medium text-gray-700"
        }, "Description", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "description",
          class: "mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.description) = $event)),
          rows: "8"
        }, null, 512), [
          [_vModelText, $data.description]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "jobUrl",
          class: "block text-sm font-medium text-gray-700"
        }, "Job URL", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "url",
          id: "jobUrl",
          class: "mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.jobUrl) = $event))
        }, null, 512), [
          [_vModelText, $data.jobUrl]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "salaryRange",
          class: "block text-sm font-medium text-gray-700"
        }, "Salary Range", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "salaryRange",
          class: "mt-1 block w-1/3 border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.salaryRange) = $event))
        }, null, 512), [
          [_vModelText, $data.salaryRange]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("label", {
          for: "date",
          class: "block text-sm font-medium text-gray-700"
        }, "Date applied", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          id: "date",
          class: "mt-1 block 1/2 border-b-2 border-gray-300 rounded-md shadow-sm focus:border-brand-500 focus:ring-brand-500",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.jobDate) = $event))
        }, null, 512), [
          [_vModelText, $data.jobDate]
        ])
      ]),
      _createVNode(_component_BaseButton, {
        type: "submit",
        text: "Add Job"
      })
    ], 32)
  ]))
}